import React, { useRef, useState } from 'react';
import clsx from 'clsx';

import { OverlayPanel } from 'primereact/overlaypanel';
import { Tooltip } from 'primereact/tooltip';

const notificationsSample = [
    {
        unix_datetime: Math.floor(Date.now() / 1000),
        is_read: false,
        icon: 'pi pi-check',
        message_body:
            'Jonathan Dovin a finis tous les tests dans la campagne Accompagnement Psychologique',
        notification_id: "4a2d419e-cc79-4111-81a6-fbcd5abca1cb",
    },
    {
        unix_datetime: 1625258592,
        is_read: false,
        icon: 'pi pi-envelope',
        message_body:
            'Un e-mail de rappel automatique a été envoyé à Elodie Dubois',
        notification_id: "0540ca71-5521-422d-bd78-01e3db1ee7ae",
    },
    {
        unix_datetime: 1625258592,
        is_read: false,
        icon: 'pi pi-info-circle',
        message_body:
            "Votre abonnement est sur le point d'expirer ! Pour le continuer, veuillez cliquer ici",
        notification_id: "f2ce6686-3096-435f-a809-dc6a714a960d",
    },
    {
        unix_datetime: 1625258592,
        is_read: false,
        icon: 'pi pi-exclamation-triangle',
        message_body:
            'Une maintenance sera en cours le 26/03/2025 à partir de 15h et devrait durer ~1 Heure',
        notification_id: "557b463c-9a62-4ec6-ad5b-3f74fea9ead4",
    },
];

const isToday = (unixTime) => {
    const date = new Date(unixTime);
    const now = new Date();
    return (
        date.getDate() === now.getDate() &&
        date.getMonth() === now.getMonth() &&
        date.getFullYear() === now.getFullYear()
    );
};

const NotificationPanel = () => {
    const notificationPanelRef = useRef(null);
    const [notificationsState, setNotificationsState] = useState(
        notificationsSample
    );

    const todayNotifications = notificationsState.filter((n) =>
        isToday(n.unix_datetime * 1000)
    );

    const olderNotifications = notificationsState.filter(
        (n) => !isToday(n.unix_datetime * 1000)
    );

    const handleMarkAllAsRead = () => {
        const updated = notificationsState.map((n) => ({ ...n, is_read: true }));
        setNotificationsState(updated);
    };

    const handleMarkAsRead = (notification_id) => {
        const updated = notificationsState.map((n) =>
            n.notification_id === notification_id ? { ...n, is_read: true } : n
        );
        setNotificationsState(updated);
    };

    const renderNotification = (notification, index, arr) => {
        const isFirst = index === 0;
        const isLast = index === arr.length - 1;
        const isAlone = arr.length === 1;

        return (
            <div
                key={notification.notification_id}
                className={clsx('notification-item', {
                    'notification-read': notification.is_read,
                    'is-first': isFirst || isAlone,
                    'is-last': isLast || isAlone,
                })}
            >
                <div className="notification-content">
                    <div className="notification-icon">
                        <i className={notification.icon}></i>
                    </div>
                    <div className="notification-message">
                        <p>{notification.message_body}</p>
                        <small>
                            {new Date(notification.unix_datetime * 1000).toLocaleString()}
                        </small>
                    </div>
                    {!notification.is_read && (
                        <div className="notification-action">
                            <i
                                className="pi pi-check"
                                onClick={() => handleMarkAsRead(notification.notification_id)}
                            ></i>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <>
            <span className="icon bell mr-3 ml-auto  is-clickable" onClick={(e) => notificationPanelRef.current.toggle(e)}>

                <i className="fa-solid fa-bell"></i>

                <OverlayPanel ref={notificationPanelRef} className="notification-panel">

                    <Tooltip target=".notification-item" content="Ceci est une preview, les notifications ne vous concernet pas réellement." position="left"
                        mouseTrackLeft={50}
                        pt={{
                            arrow: {
                                style: { display: 'none' }
                            }
                        }}
                    />

                    {todayNotifications.length > 0 && (
                        <>
                            <div className="separator">Aujourd'hui</div>
                            {todayNotifications.map((n, i) =>
                                renderNotification(n, i, todayNotifications)
                            )}
                        </>
                    )}
                    {olderNotifications.length > 0 && (
                        <>
                            <div className="separator">Avant</div>
                            {olderNotifications.map((n, i) =>
                                renderNotification(n, i, olderNotifications)
                            )}
                        </>
                    )}
                    <div className="columns is-mobile is-vcentered mt-3">
                        <div
                            className="column is-clickable has-text-centered"
                            onClick={handleMarkAllAsRead}
                        >
                            <i className="pi pi-list-check"></i>
                        </div>
                        <div className="column has-text-centered is-clickale">
                            <i className="fa-solid fa-gear"></i>
                        </div>
                    </div>
                </OverlayPanel>
            </span>
        </>
    );
};

export default NotificationPanel;